/*
 * Used to expose an api that can be used to start a chat from elsewhere on the web page.
 * Normally this will happen after the chat ready callback from the server.
 */
import { BoostActions } from '../actions/boostActions';
import { RequestCallbackActions } from '../actions/callguideRequestCallbackActions';
import { WebtrendsActions } from '../actions/webtrendsActions';

export const proactiveService = {
  init(
    requestCallbacks: RequestCallbackActions,
    webtrendsActions: WebtrendsActions,
    toggleChatWindowVisible: (b: boolean, n?: number) => void,
    boostActions: BoostActions
  ) {
    window.CallGuideChatClient.api.startRobotChat = boostActions.startRobotChat;

    /**
     * Initiate a chat request to the server.
     * If values are not provided, default values will be used.
     * @param entrance - CallGuide chat entrance name as a string
     * @param errand - The errand name as a string
     * @param initialQuestion - The initial question as a string, max length: 512
     * @param contactData - Contact data as an object with key value data pairs.
     */
    window.CallGuideChatClient.api.startChat = requestCallbacks.startChatTrack;

    /**
     * Hide the chat activation-tab.
     * If chatWindowIsVisible is true in local storage, then ignore
     * to remove the chat activation because the user has already expanded
     * the application and its visible.
     */
    window.CallGuideChatClient.api.hideChatActivations =
      requestCallbacks.hideChatActivations;

    /**
     * Show the chat offer
     */
    window.CallGuideChatClient.api.showChatActivations =
      requestCallbacks.showChatActivations;

    /**
     * Show chat window
     */
    window.CallGuideChatClient.api.showChatWindow = () => {
      toggleChatWindowVisible(true);
    };

    /**
     * Hide chat window
     */
    window.CallGuideChatClient.api.hideChatWindow = () => {
      toggleChatWindowVisible(false);
    };

    /**
     *
     */
    window.CallGuideChatClient.api.acceptChatOffer = () => {
      window.CallGuide?.api.pw.acceptChat();
      webtrendsActions.trackAcceptChatOffer();
    };

    /**
     * Show the chat offer
     */
    window.CallGuideChatClient.api.declineOffer = () => {
      window.CallGuide?.api.pw.declineOffer();
      webtrendsActions.trackDeclineOffer();
    };

    /**
     * Show the chat offer
     */
    window.CallGuideChatClient.api.declineFurtherOffers = () => {
      window.CallGuide?.api.pw.declineFurtherOffers();
      webtrendsActions.trackDeclineFurtherOffers();
    };
  }
};
